var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTankIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 402,
    width: 582,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", {
    stroke: "#000066",
    fill: "none"
  }, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    strokeWidth: "6px",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#000066",
    fill: "none",
    id: "svg_1",
    d: "m213.43,243.34l-142.36,0a38.74,38.74 0 0 1 -38.73,-38.74l0,-127.06l48.46,-59.3l107,0a46.71,46.71 0 0 1 46.68,46.76l0,157.3a21,21 0 0 1 -21.05,21.04z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: "4px",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#000066",
    fill: "none",
    id: "svg_2",
    d: "m148.23,25.89l39.54,0a39.06,39.06 0 0 1 39.05,39.11l0,39.53",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: "6px",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#000066",
    fill: "none",
    id: "svg_3",
    y2: 44.39,
    y1: 60.64,
    x2: 29.78,
    x1: 46.04,
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: "6px",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#000066",
    fill: "none",
    id: "svg_4",
    y2: 35.68,
    y1: 20.78,
    x2: 63.48,
    x1: 48.58,
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: "6px",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#000066",
    fill: "none",
    id: "svg_5",
    y2: 12.66,
    y1: 53.89,
    x2: 55.22,
    x1: 21.52,
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: "6px",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#000066",
    fill: "none",
    id: "svg_6",
    y2: 111.02,
    y1: 18.24,
    x2: 233.36,
    x1: 140.58,
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: "6px",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#000066",
    fill: "none",
    id: "svg_7",
    d: "m168.48,149.6a35.07,35.07 0 1 1 -70.14,0c0,-19.37 35.07,-72.69 35.07,-72.69s35.07,53.32 35.07,72.69z",
    className: "cls-1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTankIcon);
export default __webpack_public_path__ + "static/media/tank-icon.f6ea6937cb802374ae5e2d83b116b271.svg";
export { ForwardRef as ReactComponent };